<div class=" mt-4">
    <section>
        <div class="row">
            <div class="col-md-12">
                <div class="float-right">
                    <button class="btn dash-btns mr-3" [routerLink]="['/PayOut/NewPayOutContact']" *ngIf="newpayout">New
                        PayOut Contact </button>
                    <button class="btn dash-btns mr-3" [routerLink]="['/PayOut/ManagePayOutContact']">Manage PayOut  Contacts
                    </button>
                    <button [routerLink]="['/reports/transactions/summary']" class="dash-btns btn">Reports</button>



                </div>
            </div>
        </div>

    </section>
    <section class="mt-3">
        <div class="">
            <div class="row">
                <div class="col-md-7">
                    <div class="card-1">
                        <div class="row">
                            <div class="col-md-12">
                               
                                <div class="text-center">
                                    <a class="view-h gary-t  " *ngIf="Viewbeneficiaries"> PayOut View Beneficiary </a>
                                    <a class="view-h gary-t " *ngIf="transactiondetails"> PayOut Add transaction details</a>
                                </div>

                                <div class="pt-3">
                                    <div class="row" *ngIf="Viewbeneficiaries">
                                        <div class="col-md-12 ">
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label>PayOut Beneficiary Key Id</label> </div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.PayOutBeneficiaryKeyId}}
                                                </div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label>PayOut Customer key Id</label> </div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.PayoutCustomerkeyId}}
                                                </div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label>Beneficiary Name</label> </div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.BeneficiaryName}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label>BankCode Type</label> </div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.BankCodeType}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label>Bank Name</label> </div>

                                                <div class="col-7 p-0 view-text"> {{rows.BankName}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label> Branch Name</label></div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.BranchName}}</div>
                                            </div>
                                            <!-- <div class="row mb-3">

                                                <div class="col-4 p-0"> <label> Address</label></div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.Address}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label> City</label></div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.City}}</div>
                                            </div>

                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label> State</label></div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.State}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label> ZipCode</label></div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.ZipCode}}</div>
                                            </div> -->

                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label>Bank Code/IFSC Code </label> </div>

                                                <div class="col-7 p-0 view-text"> {{rows.BankCode}}</div>
                                            </div>
                                            <div class="row mb-3" *ngIf="CrossAccNo">

                                                <div class="col-4 p-0"><label> Account Number </label> </div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.AccountNumber}}
                                                    <span color="accent" id="fullCardNo." (click)="onSelect(true)">
                                                        <i class="fab fa-sistrix"
                                                            style="color:#41c0e8;font-size:16px; font-weight:600;"></i>
                                                    </span>

                                                </div>
                                            </div>

                                            <div class="row mb-3" *ngIf="FullAccNo">

                                                <div class="col-4 p-0"><label> Account Number </label> </div>

                                                <div class="col-7 p-0 view-text robot"> {{FullAccountNumber}}
                                                   
                                                </div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label> BankAccount Type </label> </div>

                                                <div class="col-7 p-0 view-text"> {{rows.BankAccountType}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label> Bank Country</label> </div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.BankCountry }}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"> <label>Verification Status</label> </div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.VerificationStatus}}
                                                </div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"><label> Verification Response </label> </div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.VerificationResponse}}
                                                </div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"><label> UpiVpa</label> </div>

                                                <div class="col-7 p-0 view-text robot"> {{rows.UpiVpa}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"><label> Prefer PayOut Account </label> </div>

                                                <div class="col-7 p-0 view-text"> {{rows.PreferPayOutAccount}}</div>
                                            </div>
                                            <div class="row mb-3">

                                                <div class="col-4 p-0"><label> Updated Date Time </label> </div>

                                                <div class="col-7 p-0 view-text"> {{rows.UpdatedDatetime | date:'d/M/yy,
                                                    h:mm a'}}</div>
                                            </div>

                                            <div class="text-left pt-3" *ngIf="Verifybeneficiary">

                                                <button class="btn dash-btns mr-2" *ngIf="rows.Status==2 && tranferAmount" id="tranfer"
                                                    color="primary" (click)="Addtransactiondetail()">Transfer
                                                    Amount</button>

                                                <button class="btn dash-btns" *ngIf="rows.Status==1 && verifybeneficiary" id="deleteben"
                                                    color="primary" (click)="statuscheck()">Verify beneficiary</button>


                                            </div>
<div class="text-left pt-3">
    <button class="btn dash-btns mr-2"  id="tranfer"
    color="primary" (click)="showkycdetails()">Kyc Details</button>

</div>
                                            <div class="text-left pt-3" *ngIf="notVerifybeneficiary">


                                                <button class="btn dash-btns"  id="deleteben"
                                                    color="primary" (click)="statuscheck()" *ngIf="verifybeneficiary">Verify beneficiary</button>


                                            </div>




                                        </div>
                                    </div>
                                    <div class="row" *ngIf="transactiondetails">
                                        <div class="col-md-12">
                                            <form>
                                                <div class="form-group p-2">
                                                 
                                                    <div class="row pt-2 mx-0" *ngIf="processorselection"> 
                                                        <div class="col-lg-12">
                                                            <div class="form-group mb-0 formgroup-tm">
                                                             
                                                                <label  class="customlabel">PayOut Processor Type*</label>
                                                                <div class="selctcustom mb-0">
                                                                    
                                                                <select class="formcontrol-user form-control"
                                                                id="PayOutProcessorType" [formControl]="PayOutProcessorType"
                                                                placeholder="PayOut Processor Type"  (ngModelChange)="processordelection()" [(ngModel)]="Processorvalue">
                                                                <!-- <option value="" disabled selected hidden>
                                                                    --Select PayOut Processor--</option> -->
                                                                    <option [value]="Processorvalue" disabled selected hidden>{{Processorvalue}}</option> 
                                                                <option *ngFor="let list of myItems">
                                                                    {{list.PayoutProcessorId}}

                                                                </option>

                                                            </select>
                                                                </div>
                                                               
                                                            </div>
                                                           
                                                        </div>
                                                    </div>


                                                    <div class="row pt-2 mx-0" *ngIf="processorselection">

                                                        <div class="col-lg-4 col-md-5">
                                                            <label >Payout AccountKey Id</label>
                                                        </div>

                                                        <div class="col-lg-6  col-md-6">
                                                            <div>
                                                                <label>{{PayoutAccountKeyId}}</label>

                                                            </div>
                                                        </div>
                                                    </div>
                                                 
                                                 
                                                 
                                                 
                                                 
                                                 
                                                 
                                                 
                                                 
                                                 
                                                    <div class="row mx-0 pt-2">

                                                        <div class="col-lg-4 col-md-5">
                                                            <label>Available Balance</label>
                                                        </div>

                                                        <div class="col-lg-6  col-md-6">
                                                            <div class="text-left">
                                                              <b>{{balance | currency:"₹"}}</b>  
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mx-0 pt-2">

                                                        <div class="col-lg-4 col-md-5">
                                                            <label>Payout CustomerkeyId</label>
                                                        </div>

                                                        <div class="col-lg-6  col-md-6">
                                                            <div class="view-text"> {{ContactId}} </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mx-0 pt-2">

                                                        <div class="col-lg-4 col-md-5">
                                                            <label>Customer Name </label>
                                                        </div>

                                                        <div class="col-lg-6  col-md-6">
                                                            <div class="view-text"> {{CustomerName.FirstName}} </div>
                                                        </div>
                                                    </div>

                                                    <div class="row mx-0 pt-2">

                                                        <div class="col-lg-4 col-md-5">
                                                            <label>Company Name </label>
                                                        </div>

                                                        <div class="col-lg-6  col-md-6">
                                                            <div class="view-text"> {{CustomerName.CompanyName}} </div>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="row pt-2 mx-0" *ngIf="singleprocessor">

                                                        <div class="col-lg-4 col-md-5">
                                                            <label >Payout AccountKey Id</label>
                                                        </div>

                                                        <div class="col-lg-6  col-md-6">
                                                            <div>
                                                                <label>{{PayoutAccountKeyId}}</label>

                                                            </div>
                                                        </div>
                                                    </div> -->

                                                    <div class="row mx-0 pt-2">

                                                        <div class="col-lg-4 col-md-5">
                                                            <label >Transaction Type </label>
                                                        </div>

                                                        <div class="col-lg-6  col-md-6">
                                                            <div>
                                                                <label>Debit</label>
                                                                <!-- <ngx-select [items]="TType" placeholder="Transaction Type" id="TransactionType" name="TransactionType" [formControl]="TransactionType" value="Debit">
                                          </ngx-select> -->
                                                            </div>
                                                            <!-- <span class="text-danger" *ngIf="TransactionType.invalid && (TransactionType.dirty || TransactionType.touched)">{{TransactionTypeerrors()}}</span> -->
                                                        </div>
                                                    </div> 
                                                    <!-- *ngIf="Beneficiary" -->
                                                    <div class="row mx-0 pt-2"> 

                                                        <div class="col-lg-12">
                                                            <div class="form-group formgroup-tm">
                                                                <label class="customlabel">PayOut Beneficiary KeyId*</label>
                                                                     <select [formControl]="beneficiarykeyid"
                                                                    placeholder="PayOutBeneficiaryKeyId" required
                                                                    (change)="getbenficarydetails()" class="formcontrol-user1 form-control">
                                                                    <option value="" disabled selected hidden>Please
                                                                        Select Beneficiary Name...</option>
                                                                    <option [value]="BeneficiarieList"
                                                                        *ngIf="Beneficiariehide">{{BeneficiarieList}}
                                                                    </option>
                                                                    <option *ngFor="let item of BeneficiarieList">
                                                                        {{item.PayOutBeneficiaryKeyId}}-{{item.BeneficiaryName}}

                                                                    </option>

                                                                </select>
                                                               
                                                               
                                                            </div>
                                                            <span class="text-danger"  *ngIf="errormessage"><a style="color: #442B66;" (click)="verify()">Click  here to</a> Verify beneficiary </span>
                                                        </div>
                                                    </div>

                                                   
                                                    <div class="row pt-2 mx-0" *ngIf="showBenificiaryName">

                                                        <div class="col-lg-4 col-md-5">
                                                            <label >Benificiary Name</label>
                                                        </div>

                                                        <div class="col-lg-6  col-md-6">
                                                            <div>
                                                                <label>{{benficiaryName}}</label>

                                                            </div>
                                                        </div>
                                                    </div>




                                                    <div class="row pt-2 mx-0"> 

                                                        <div class="col-lg-12">
                                                            <div class="form-group mb-0 formgroup-tm">
                                                                <!-- <ngx-select [items]="PayType" id="PayOutType" placeholder="PayOutType" name="PayOutType"  [formControl]="PayOutType" ></ngx-select>
                                -->
                                                                <label  class="customlabel">PayOut Type*</label>
                                                                <div class="selctcustom mb-0">
                                                                    <ngx-select [items]="PayType" placeholder="PayOutType"
                                                                    id="PayOutType" name="PayOutType"
                                                                    [formControl]="PayOutType"
                                                                    (blur)="onButtonTypeChange()">
                                                                </ngx-select>
                                                                </div>
                                                               
                                                            </div>
                                                           
                                                        </div>
                                                    </div>


                                              

                                                    <div class="row pt-2 mx-0" *ngIf="dateoption"> 
                                                        <div class="col-lg-12">
                                                            <div class="form-group formgroup-tm">
                                                                <label  class="customlabel" >PayOutDate*</label>
                                                                <input type="date" class="formcontrol-user1 form-control"
                                                                    id="Date" [formControl]="Date"
                                                                    (change)="dateselection()" required>
                                                            </div>
                                                            
                                                        </div>
                                                    </div>

                                                    <!-- <div class="row pt-2">

                          <div class="col-lg-4 col-md-5">
                              <label class="customlabel">Transaction Type<span
                                      class="text-danger">*</span></label>
                          </div>
                            
                            <div class="col-lg-6  col-md-6">
                              <div class="form-group">
                                <ngx-select [items]="TType" placeholder="Transaction Type" id="TransactionType" name="TransactionType" [formControl]="TransactionType">
                                </ngx-select>
                                                          </div>
                              <span class="text-danger" *ngIf="TransactionType.invalid && (TransactionType.dirty || TransactionType.touched)">{{TransactionTypeerrors()}}</span>
                          </div>
                      </div> -->
                                                    <div class="row mx-0 pt-2"> 

                                                        <div class="col-lg-12">
                                                            <div class="form-group formgroup-tm">
                                                                <label class="customlabel" >Payment Type*</label>
                                                                <div class="selectcustom mb-0">
                                                                    <ngx-select [items]="PType" placeholder="Payment Type"
                                                                    id="PaymentType" name="PaymentType"
                                                                    [formControl]="PaymentType" (ngModelChange)="PaymentTypeChange()"> 
                                                                </ngx-select>
                                                                </div>
                                                              
                                                                <!-- <input type="text" placeholder="Payment Type" id="PaymentType" name="PaymentType" [formControl]="PaymentType"> -->
                                                            </div>
                                                           
                                                        </div>
                                                    </div>

                                                    <div class="row mx-0 pt-2" *ngIf="UpiIdShow"> 
                                                        <div class="col-lg-12">
                                                            <div class="form-group formgroup-tm">
                                                                <label  class="customlabel" >UPI Id</label>
                                                                <input class="formcontrol-user1 form-control" type="text"
                                                                    placeholder="Upi Id" id="UpiId" name="UpiId"
                                                                    [formControl]="UpiId" >
                                                            </div>
                                                           
                                                        </div>
                                                    </div>
                                                    <div class="row pt-2 mx-0"> 
                                                        <div class="col-lg-12">
                                                            <div class="form-group formgroup-tm">
                                                                <label  class="customlabel" >Amount*</label>
                                                                <input class="formcontrol-user1 form-control" type="text"
                                                                    placeholder="Amount" id="Amount" name="Amount"
                                                                    [formControl]="Amount" (change)="AmountCheck()">
                                                            </div>
                                                            
                                                        </div>
                                                    </div>







                                                    <div class="row pt-2 mx-0"> 
                                                        <div class="col-lg-12">
                                                            <div class="form-group formgroup-tm">
                                                            <label class="customlabel" *ngIf="nonmandatepaymentreason">Payment Reason</label>
                                                            <label class="customlabel" *ngIf="mandatepaymentreason">Payment Reason*</label>
                                                                <input class="formcontrol-user1 form-control" type="text"
                                                                    placeholder="Payment Reason" id="PaymentReason" name="Amount"
                                                                    [formControl]="PaymentReason" (ngModelChange)="productdata()">
                                                            </div>
                                                           
                                                        </div>
                                                    <span *ngIf="Paymentreasonmandate"></span>
                                                    </div>




                                                    <div class="row mx-0 formgroup-tm">

                                                        <div class="col-lg-4 col-md-5">
                                                            <label  >Fee Amount<span
                                                                    class="text-danger"></span></label>
                                                        </div>

                                                        <div class="col-lg-6  col-md-6">
                                                            <div class="text-left">
                                                              <b>{{TotalFeeAmount | currency:"₹ "}}</b>  
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row mx-0 formgroup-tm">

                                                        <div class="col-lg-4 col-md-5">
                                                            <label>Total Amount<span
                                                                    class="text-danger"></span></label>
                                                        </div>

                                                        <div class="col-lg-6  col-md-6">
                                                            <div class="text-left">
                                                              <b>{{TotalAmount | currency:"₹ "}}</b>  
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="text-left pt-3">

                                                        <button class="btn dash-btns" id="Savecoupon" color="primary"
                                                            [disabled]="Amount.invalid|| PaymentType.invalid || PayOutType.invalid||dateerrormessage ||balanceerromessage || feesetuperromessage ||beneficiarykeyid.invalid||errormessage||RTGSerrormessage||RTGSAmountErromessage ||Paymentreasonmandate||IMPSAmountErromessage || transactionbtn"
                                                            (click)="payoutmakerandchecker()">Initiate The
                                                            Transfer</button>
                                                    </div>

                                                </div>
                                            </form>

                                        </div>
                                    </div>
                                    <div class="row" *ngIf="benficiaryerrormessage">
                                        <div class="col-md-12 p-0">
                                            <div>
                                                <div class="row mx-0">
                                                    <div class="col-md-12">
                                                        <div class="text-center py-3">
                                                            <label>"Note : Don't have Beneficiary Account please Create
                                                                One Beneficiary" </label>
                                                        </div>
                                                        <div class="text-center">
                                                            <button class="btn dash-btns " id="Savecoupon"
                                                                color="primary" (click)="CreateBeneficiary()">Create
                                                                benficiary Account</button>


                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                               
                                </div>

                            </div>
                        </div>
                        
                    </div>
                </div>
                
                <div class="col-md-5">
                    <div class="card-1 p-2">
                      <div class="text-center">
                        <img src="https://fastswiff.com/assets/img/security.png" class="w-100" alt="">
          
                      </div>
                      <div class="mt-4">
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"   *ngIf="beneficiarykeyid.invalid && (beneficiarykeyid.dirty || beneficiarykeyid.touched)">{{PayOutbeneficiarykeyid()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"   *ngIf="PayOutType.invalid && (PayOutType.dirty || PayOutType.touched)">{{PayOutTypeerrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="Date.invalid && (Date.dirty || Date.touched)">{{Dateerrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="dateerrormessage">please  select valid date</div>

                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                            *ngIf="PaymentType.invalid && (PaymentType.dirty || PaymentType.touched)">{{PaymentTypeerrors()}}</div>
                            <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="RTGSerrormessage">RTGS is not allowed for this time </div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0" 
                            *ngIf="Amount.invalid && (Amount.dirty || Amount.touched)">{{Amounterrors()}}</div>
                        <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="balanceerromessage">Invalid
                            Amount</div>
                            <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="feesetuperromessage">Fee is not setup, can not Initiate Transaction.</div>
                         <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="RTGSAmountErromessage">RTGS is not allowed for less than 2 lac</div>
                         <div  class="alert alert-danger py-2 mb-0 px-2 border-r border-0"  *ngIf="IMPSAmountErromessage">IMPS is not allowed for more than 5 lac</div>
                      </div>
                    </div>
                  </div>
            </div>
            <div class="row">
                <div class="col-md-12" *ngIf="showkyctab">
                    <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
                        [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="kycdata">
                        <ngx-datatable-column name="TransactionId" [width]="200">
                            <ng-template let-row="row" ngx-datatable-cell-template> {{row.TransactionId}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Level">
                            <ng-template let-row="row" ngx-datatable-cell-template> {{row.Level}} </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="AadharCard Number">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <div class="robot font400">{{row.AadharCardNumber}}</div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Name On AadharCard">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <div class="robot font400">{{row.NameonAadharCard}}</div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="File view">
                            <ng-template let-row="row" let-value="row" ngx-datatable-cell-template>
                                <!-- Button to Open the Modal -->
                                <i *ngIf="row.AadharCardContentType ==='image/png'">
                                    <button type="button" class="btn btn-primary" (click)="ModelClick(value)"
                                        data-toggle="modal" data-target="#myModal">
                                        View File
                                    </button>
                                </i>
                
                                <i *ngIf="row.AadharCardContentType ==='image/jpeg'">
                                    <button type="button" class="btn btn-primary" (click)="ModelClick(value)"
                                        data-toggle="modal" data-target="#myModal">
                                        View File
                                    </button>
                                </i>
                                <i *ngIf="row.AadharCardContentType ==='application/pdf'">
                                    <button type="button" class="btn btn-primary" (click)="ModelClick(value)">
                                        View File
                                    </button>
                                </i>
                
                
                
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="IpAddress">
                            <ng-template let-row="row" ngx-datatable-cell-template> {{row.IPAddress}}
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="Source">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <div class=" robot font400">{{row.Source}}</div>
                            </ng-template>
                        </ngx-datatable-column>
                        <ngx-datatable-column name="UpdatedDatetime">
                            <ng-template let-row="row" ngx-datatable-cell-template>
                                <div class=" robot font400">{{row.UpdatedDateTime | date:'d/M/yy, h:mm a' }}</div>
                            </ng-template>
                        </ngx-datatable-column>
                    </ngx-datatable>
                </div>
            </div>
        </div>
    </section>
</div>
<div class="modal fade" id="myModal" role="dialog" aria-labelledby="myModalLabel" data-backdrop="false"
    onContextMenu="return false;">
    <div class="modal-dialog modal-lg">
        <div class="modal-content card-1">

            <!-- Modal Header -->
            <div class="modal-header b0">

                <button type="button" class="close text-danger" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <!-- <img src="data:image/jpeg;base64,{{imgcontent}}"> -->
                <div *ngIf="imgcontentType ==='image/png'">
                    <img src="data:image/jpeg;base64,{{imgcontent}}" class="w-100">
                </div>
                <div *ngIf="imgcontentType ==='image/jpeg'">
                    <img src="data:image/jpeg;base64,{{imgcontent}}" class="w-100">
                </div>
                <div *ngIf=" imgcontentType ==='application/pdf'">
                    <!-- <iframe src="data:application/pdf;base64,{{imgcontent}}"></iframe> -->
                    <!-- //window.location.href="data:application/pdf;base64,{{imgcontent}}" -->
                    <!-- $window.Open("data:application/pdf;base64,{{imgcontent}}"); -->
                    <iframe src='data:application/pdf;base64,{{imgcontent}}' height="300" width="300" style="border: 0;"
                        frameborder="0"></iframe>


                </div>

            </div>


        </div>
    </div>
</div>